import React, { useEffect, useState } from "react";
import { useLoader } from "../../context/LoaderContext";
// import Count from "../../components/user/admin/Count";
import AdminMemberTable from "../../components/user/admin/AdminMemberTable";
import { IMemberListData, IMemberShipType } from "../../exports/interfaces";
import { fetchMemberLists, fetchMemberShipType } from "../../api/MemberApi";
import { dynamicFailed } from "../../hooks/useToast";
import { useUserDataContext } from "../../context/UserDataContext";
import { openLogin } from "../../exports/exports";
import { checkUser } from "../../api/UserApi";
import { useEventContext } from "../../context/EventContext";
import { fetchEventData } from "../../api/EventApi";
import StatusCount from "../../components/user/admin/StatusCount";

const AdminMembers = () => {
  const { setLoading } = useLoader();
  const { eventData, setEventData } = useEventContext();
  const [listMemberData, setListMemberData] = useState<IMemberListData[]>([]);
  // const [memberCount, setMemberCount] = useState<number>(0);
  // const [countryCount, setCountryCount] = useState<number>(0);
  const [pendingCount, setPendingCount] = useState<number>(0);
  const [approveCount, setApproveCount] = useState<number>(0);
  const [activeCount, setActiveCount] = useState<number>(0);
  const [rejectedCount, setRejectedCount] = useState<number>(0);
  const [expiredCount, setExpiredCount] = useState<number>(0);
  const [membershipType, setMembershipType] = useState<IMemberShipType[]>([]);
  const { userData, setUserData } = useUserDataContext();
  const [selectedStatus, setSelectedStatus] = useState<string[]>([]);
  const accessToken = localStorage.getItem("frcsit:access-token");
  useEffect(() => {
    if (!userData) {
      if (accessToken === null || accessToken === undefined) {
        openLogin();
        return;
      }
      Promise.all([checkUser(accessToken)])
        .then(([userData]) => {
          setUserData(userData);
          userData?.data?.roles[0]?.name !== "sa" && openLogin();
        })
        .catch(() => {
          dynamicFailed("Server Error");
        });
    }
  }, [accessToken, setUserData, userData]);

  useEffect(() => {
    setLoading(true);
    if (eventData.length === 0) {
      Promise.all([fetchEventData()])
        .then(([eventData]) => {
          setEventData(eventData);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        })
        .catch(() => {
          dynamicFailed("Server Error");
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        });
    }
  }, [eventData.length, setEventData, setLoading]);

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchMemberLists(), fetchMemberShipType()])
      .then(([listMemberData, memberShipTypeData]) => {
        setListMemberData(listMemberData);
        // const activeMembers = listMemberData.filter(
        //   (member: IMemberListData) => member.attributes?.Status === "Active"
        // );
        // setMemberCount(activeMembers.length);
        // const countries = activeMembers.map((member: IMemberListData) =>
        //   member.attributes?.Country?.trim()
        // );
        // const uniqueCountries = new Set(countries.filter(Boolean));
        // setCountryCount(uniqueCountries.size);
        setPendingCount(
          listMemberData.filter(
            (member: IMemberListData) =>
              member.attributes?.Status === "Pending",
          ).length,
        );
        setApproveCount(
          listMemberData.filter(
            (member: IMemberListData) =>
              member.attributes?.Status === "Approved",
          ).length,
        );
        setActiveCount(
          listMemberData.filter(
            (member: IMemberListData) => member.attributes?.Status === "Active",
          ).length,
        );
        setRejectedCount(
          listMemberData.filter(
            (member: IMemberListData) =>
              member.attributes?.Status === "Rejected",
          ).length,
        );
        setExpiredCount(
          listMemberData.filter(
            (member: IMemberListData) =>
              member.attributes?.Status === "Expired",
          ).length,
        );
        setMembershipType(memberShipTypeData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [listMemberData.length, setLoading]);

  return (
    <>
      {/* <Count
        Title={"Members"}
        memberCount={memberCount}
        countryCount={countryCount}
      /> */}
      <StatusCount
        Title={"Members List"}
        pendingCount={pendingCount}
        approveCount={approveCount} 
        activeCount={activeCount}
        rejectedCount={rejectedCount}
        expiredCount={expiredCount}
        selectedStatus={selectedStatus}
        setSelectedStatus={setSelectedStatus}
      />
      <AdminMemberTable
        listMemberData={listMemberData}
        membershipType={membershipType}
        selectedStatus={selectedStatus}
        setSelectedStatus={setSelectedStatus}
      />
    </>
  );
};

export default AdminMembers;
